module.exports = __webpack_public_path__ + "static/media/_hong-kong.76aa7532.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_hong-kong.svg
// module id = 2328
// module chunks = 7